module.exports = __webpack_public_path__ + "img/spray-can.b17b969.png";